import VipBanner, { type VipBannerProps } from './VipBanner'

export { type VipBannerProps }
export default VipBanner
